import React, { lazy, Suspense, useState, useEffect, useCallback } from 'react';
import { GET_PARENT } from '../common';
import { connect } from 'react-redux';
import { withRouter } from "react-router-dom";
import * as userAction from '../redux/actions/userAction';
import * as zakat from '../redux/actions/zakatActions';
import * as zakatCalc from '../redux/actions/zakatCalcAction';
import { withTranslation } from "react-i18next";
import { APP_FLOW } from '../common/constant';
import { MOSQUE_BG, PRAYER } from '../common/images-s3';
import Footer from '../section/footer/footer';
import { getAppFlow } from '../views/utils/app.utils';
import { ENROL_FIELDS_MAX_CHAR_ONBEHALF } from '../common';

const ImageLoader = lazy(() => import('../common/image-loader'));

export const optionsHeaderData = {
    title: 'Select an option',
    subTitle: 'Next - Selected Action',
    steps: 3
}

const QuestionAire = (props) => {
    const { t, i18n, dispatch, user, homepage, setIsInitial } = props;
    const appFlow = getAppFlow();
    const isFidyah = appFlow === APP_FLOW.FIDYAH;

    const [state, setState] = useState({
        IRASInclusion: user.hasIRASInclusion ?? null,
        isDisabled: true,
        isDeceased: user.isDeceased ?? null,
        isBusiness: user.isBusinessPayer ?? null,
        others: user.isOthers ?? null,
        isIRAS: user.hasIRASInclusion !== null && user.isDeceased === false,
        note: user.isBusinessPayer || user.isDeceased,
        onBehalfOf: user.userData?.onbehalfof || '',
        onBehalfofError: '',
        isAlive: user.isDeceased === false
    });

    const cleanText = (text) => text.replace(/[\n+\f+\r+\t+\v+\s+]/gim, '');

    const handleOptionSelection = useCallback((e, type) => {
        const ele = GET_PARENT(e.target, 'BUTTON');
        const parent = ele?.parentNode;
        parent?.childNodes.forEach(item => item.classList.remove('selected'));
        ele?.classList.add('selected');

        const value = cleanText(e.target.innerText);
        if (type === 'payer') {
            if (value === 'Others' || value === 'Oranglain') {
                setState(prev => ({
                    ...prev,
                    others: true,
                    isBusiness: false,
                    isDeceased: null,
                    isIRAS: false,
                    IRASInclusion: null,
                    isDisabled: true,
                    note: false,
                    onBehalfOf: '',
                    onBehalfofError: '',
                    isAlive: false
                }));
                dispatch(userAction.updateUserData({ ...user.userData, onbehalfof: '' }));
            } else if (value === 'Business' || value === 'Perniagaan') {
                setState(prev => ({
                    ...prev,
                    others: false,
                    isBusiness: true,
                    isIRAS: false,
                    isDeceased: false,
                    IRASInclusion: null,
                    isDisabled: false,
                    note: true,
                    onBehalfOf: '',
                    onBehalfofError: '',
                    isAlive: false
                }));
            } else {
                setState(prev => ({
                    ...prev,
                    others: false,
                    isBusiness: false,
                    isIRAS: true,
                    isDeceased: false,
                    IRASInclusion: null, // Reset IRAS for Myself
                    isDisabled: true,
                    note: false,
                    onBehalfOf: '',
                    onBehalfofError: '',
                    isAlive: false
                }));
                dispatch(userAction.updateIRASInclusion(null));
            }
        } else if (type === 'deceased') {
            const isAlive = value === 'Alive' || value === 'Masihhidup';
            setState(prev => ({
                ...prev,
                isDeceased: !isAlive,
                isIRAS: isAlive,
                IRASInclusion: isAlive ? null : null,
                isDisabled: true, // Require onBehalfOf in Fidyah
                note: !isAlive,
                onBehalfOf: '',
                onBehalfofError: '',
                isAlive
            }));
            dispatch(userAction.updateUserData({ ...user.userData, onbehalfof: '' }));
            if (isAlive) {
                dispatch(userAction.updateIRASInclusion(null));
            }
        } else if (type === 'iras') {
            const isYes = value === 'Yes' || value === 'Ya';
            setState(prev => ({
                ...prev,
                IRASInclusion: isYes,
                isDisabled: prev.others && !prev.isDeceased ? !prev.onBehalfOf || prev.onBehalfofError : false,
                note: false
            }));
        }
    }, [dispatch, user.userData]);

    const handleOnBehalfOf = useCallback((e) => {
        const inputValue = e.target.value.toUpperCase();
        const format = /^[a-zA-Z\s,&]+$/;
        let error = "";

        if (!inputValue.trim()) {
            error = "Enter on behalf of name";
        } else if (/^\s+/.test(inputValue)) {
            error = "Enter valid on behalf of name";
        } else if (!format.test(inputValue)) {
            error = "Enter valid on behalf of name";
        } else if (inputValue.trim().length > 500) {
            error = "Enter valid on behalf of name";
        } else {
            const words = inputValue.trim().split(/\s+/);
            const restrictedWords = words.some(word => {
                const lower = word.toLowerCase();
                return lower === "hamba allah" || lower === "hamba" || lower === "hambaallah" || lower === "anonymous";
            });
            if (restrictedWords) {
                error = "Enter valid on behalf of name";
            }
        }

        setState(prev => ({
            ...prev,
            onBehalfOf: inputValue,
            onBehalfofError: error,
            isDisabled: prev.isBusiness ? false :
                       !prev.others ? prev.IRASInclusion === null :
                       prev.isDeceased === null ? true :
                       isFidyah ? !(inputValue && !error) :
                       prev.isDeceased ? !(inputValue && !error) :
                       prev.IRASInclusion === null || !(inputValue && !error)
        }));
        dispatch(userAction.updateUserData({ ...user.userData, onbehalfof: inputValue }));
    }, [dispatch, user.userData, isFidyah]);

    const setData = useCallback(() => {
        if (state.isBusiness) {
            dispatch(userAction.updateIsOthers(false));
            dispatch(userAction.updateBusinessUser(true));
            dispatch(userAction.updateIsDeceased(false));
            dispatch(userAction.updateIRASInclusion(false));
        } else if (!state.isBusiness && !state.others) {
            dispatch(userAction.updateIsOthers(false));
            dispatch(userAction.updateBusinessUser(false));
            dispatch(userAction.updateIsDeceased(false));
            dispatch(userAction.updateIRASInclusion(state.IRASInclusion));
        } else {
            dispatch(userAction.updateIsOthers(true));
            dispatch(userAction.updateUserData({ ...user.userData, onbehalfof: state.onBehalfOf }));
            if (state.isDeceased) {
                dispatch(userAction.updateBusinessUser(false));
                dispatch(userAction.updateIsDeceased(true));
                dispatch(userAction.updateIRASInclusion(false));
            } else {
                dispatch(userAction.updateIRASInclusion(state.IRASInclusion));
                dispatch(userAction.updateBusinessUser(false));
                dispatch(userAction.updateIsDeceased(false));
            }
        }

        dispatch(zakat.resetZakatData());
        dispatch(zakat.resetFitrahData());
        dispatch(zakatCalc.resetFitrahData());
        dispatch(zakatCalc.resetZakatCalcData());
        // setIsInitial(false);
    }, [dispatch, state, setIsInitial, user.userData]);

    useEffect(() => {
        const initializeSelections = () => {
            // Clear all selections initially
            document.querySelectorAll('.payingFor').forEach(item => item.classList.remove('selected'));
            document.querySelectorAll('.deceasedSelection').forEach(item => item.classList.remove('selected'));
            document.querySelectorAll('.irasSelecton').forEach(item => item.classList.remove('selected'));

            // Apply selections only if explicitly set in Redux
            if (state.isBusiness === true) {
                document.querySelectorAll('.payingFor').forEach(item => {
                    const text = cleanText(item.innerText);
                    if (text === 'Business' || text === 'Perniagaan') {
                        item.classList.add('selected');
                    }
                });
            } else if (state.others === true) {
                document.querySelectorAll('.payingFor').forEach(item => {
                    const text = cleanText(item.innerText);
                    if (text === 'Others' || text === 'Oranglain') {
                        item.classList.add('selected');
                    }
                });
                if (state.isDeceased === true) {
                    document.querySelectorAll('.deceasedSelection').forEach(item => {
                        const text = cleanText(item.innerText);
                        if (text === (i18n.language === 'ms' ? 'Telahmeninggaldunia' : 'Deceased')) {
                            item.classList.add('selected');
                        }
                    });
                } else if (state.isDeceased === false) {
                    document.querySelectorAll('.deceasedSelection').forEach(item => {
                        const text = cleanText(item.innerText);
                        if (text === (i18n.language === 'ms' ? 'Masihhidup' : 'Alive')) {
                            item.classList.add('selected');
                        }
                    });
                }
            } else if (state.others === false && state.isBusiness === false) {
                document.querySelectorAll('.payingFor').forEach(item => {
                    const text = cleanText(item.innerText);
                    if (text === 'Myself' || text === 'Dirisaya') {
                        item.classList.add('selected');
                    }
                });
            }

            if (state.isIRAS && state.IRASInclusion !== null) {
                document.querySelectorAll('.irasSelecton').forEach(item => {
                    const text = cleanText(item.innerText);
                    if (text === (state.IRASInclusion ? (i18n.language === 'ms' ? 'Ya' : 'Yes') : (i18n.language === 'ms' ? 'Tidak' : 'No'))) {
                        item.classList.add('selected');
                    }
                });
            }
        };

        initializeSelections();

        // Updated isDisabled logic
        let newIsDisabled = true;
        if (state.isBusiness) {
            newIsDisabled = false;
            setState(prev => ({ ...prev, note: true, isIRAS: false }));
        } else if (!state.isBusiness && !state.others) {
            newIsDisabled = isFidyah && state.isIRAS ? false : state.IRASInclusion === null;
            setState(prev => ({ ...prev, note: false }));
        } else {
            const isAliveOrDeceased = state.isDeceased !== null;
            if (state.isDeceased && state.onBehalfOf && !state.onBehalfofError) {
                newIsDisabled = false;
                setState(prev => ({ ...prev, note: true }));
            } else if (isFidyah) {
                newIsDisabled = !(isAliveOrDeceased && state.onBehalfOf && !state.onBehalfofError);
            } else {
                newIsDisabled = state.IRASInclusion === null || !(isAliveOrDeceased && state.onBehalfOf && !state.onBehalfofError);
            }
            setState(prev => ({ ...prev, note: false }));
        }

        setState(prev => ({
            ...prev,
            imgMosqueBG: MOSQUE_BG,
            imgPrayer: PRAYER,
            isDisabled: newIsDisabled
        }));
    }, [state.isBusiness, state.others, state.isDeceased, state.isIRAS, state.IRASInclusion, state.onBehalfOf, state.onBehalfofError, i18n.language, isFidyah]);

    const handleNext = () => {
        props.setHeaderData(optionsHeaderData);
        dispatch(userAction.updateUserSteps(optionsHeaderData));
        setData();
    };

    const handleSkip = () => {
        console.log('handleSkip');
    };

    return (
        <div className='flow-view with-footer'>
            <div className={`landing-page initial-start ${homepage.lang || ''}`}>
                <div className='c-initial'>
                    <div className='c-questions'>
                        <div className='c-questions-list c-paying-for'>
                            <h3 className='ques'>{t('initial_page_text1')}</h3>
                            <div className='c-options'>
                                {(isFidyah
                                    ? ['initial_myself', 'initial_others']
                                    : ['initial_myself', 'initial_others', 'initial_business']
                                ).map((key, index) => (
                                    <button
                                        key={index}
                                        type='button'
                                        className='payingFor btn btn-light noselect'
                                        onClick={(e) => handleOptionSelection(e, 'payer')}
                                    >
                                        <span className='name'>{t(key)}</span>
                                        <div className='tick'></div>
                                    </button>
                                ))}
                            </div>
                        </div>
                        {state.others && (
                            <div className='c-questions-list c-others'>
                                <h3 className='ques'>{t('initial_the person_is')}</h3>
                                <div className='c-options'>
                                    {['initial_deceased', 'initial_alive'].map((key, index) => (
                                        <button
                                            key={index}
                                            type='button'
                                            className='deceasedSelection btn btn-light noselect'
                                            onClick={(e) => handleOptionSelection(e, 'deceased')}
                                        >
                                            <span className='name'>{t(key)}</span>
                                            <div className='tick'></div>
                                        </button>
                                    ))}
                                </div>
                            </div>
                        )}
                        {state.isIRAS && !isFidyah && (
                            <div className='c-questions-list is-iras'>
                                <h3 className='ques'>{t('initial_declare_note')}</h3>
                                <div className='c-options'>
                                    {['initial_text_yes', 'initial_text_no'].map((key, index) => (
                                        <button
                                            key={index}
                                            type='button'
                                            className='irasSelecton btn btn-light noselect'
                                            onClick={(e) => handleOptionSelection(e, 'iras')}
                                        >
                                            <span className='name'>{t(key)}</span>
                                            <div className='tick'></div>
                                        </button>
                                    ))}
                                </div>
                            </div>
                        )}
                        {state.others && state.isDeceased !== null && (
                            <div className='c-questions-list form on-behalf-of w-100'>
                                <div className="form-group mb-0 w-100">
                                    <label className="cust-label">On Behalf Of <span className='star'>*</span></label>
                                    <input
                                        type="text"
                                        id="onbehalfof"
                                        name="onbehalfof"
                                        className={`form-control ${state.onBehalfofError ? 'is-invalid' : ''}`}
                                        placeholder="Enter name"
                                        maxLength={ENROL_FIELDS_MAX_CHAR_ONBEHALF}
                                        value={state.onBehalfOf}
                                        onChange={handleOnBehalfOf}
                                        onBlur={handleOnBehalfOf}
                                        autoComplete='off'
                                        required
                                    />
                                    {state.onBehalfofError && (
                                        <span className="invalid-feedback">{state.onBehalfofError}</span>
                                    )}
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
            <Footer
                isSkipButtonVisible={false}
                handleNext={handleNext}
                handleSkip={handleSkip}
                disabled={state.isDisabled}
            />
        </div>
    );
};

const mapStateToProps = (state) => ({
    zakatCalc: state.zakatCalcReducer,
    homepage: state.homepageReducer,
    zakat: state.zakatReducer,
    user: state.userReducer
});

export default withRouter(connect(mapStateToProps)(withTranslation()(QuestionAire)));